import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown"; // Make sure this is installed
import { useForm } from "react-hook-form";
import FormProcessingSpinner from "../common/FormProcessingSpinner";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import {
  fetchJobAlert,
  saveJobAlert,
  deleteJobAlert,
  updateJobAddStatus,
} from "../../states/actions/jobAlerts";
import { useSelector, useDispatch } from "react-redux";
import * as paths from "../../constants/paths";
import Breadcrumb from "../common/BreadCrumb";
import Text from "../common/Text";
const JobAlert = () => {
  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    { name: "Job Alerts", link: "/job-alerts" },
  ];
  // A member arriving from a thin search brings the term they looked for.
  // Making them retype it is the quickest way to lose them at the last step.
  const [alertParams] = useSearchParams();
  const presetKeyword = alertParams.get("keyword") || "";

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ defaultValues: { keyword: presetKeyword } });

  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedLevelsError, setSelectedLevelsError] = useState(false);
  const [selectedLocationsError, setSelectedLocationsError] = useState(false);

  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchJobAlerts.content);
  const addStatus = useSelector((state) => state.fetchJobAlerts.addStatus);
  const alerts = useSelector((state) => state.fetchJobAlerts.alerts);
  const isLoading = useSelector((state) => state.fetchJobAlerts.isLoading);
  const isFormProcessing = useSelector(
    (state) => state.fetchJobAlerts.isFormProcessing
  );
  const isDeleting = useSelector((state) => state.fetchJobAlerts.isDeleting);
  // const activePlan = useSelector((state) => state.fetchSiteSettings.activePlan);
  // const isSiteSettingsLoading = useSelector(
  //   (state) => state.fetchSiteSettings.isLoading
  // );
  // useEffect(() => {
  //   if (!isSiteSettingsLoading) {
  //     if (!activePlan || [4, 7].includes(Number(activePlan?.plan_id))) {
  //       window.location.href = `${paths.SITE_BASE_URL}/subscription`;
  //     }
  //   }
  // }, [isSiteSettingsLoading, activePlan]);

  useEffect(() => {
    dispatch(fetchJobAlert());
  }, []);
  // console.log(addStatus, "addStatus");

  useEffect(() => {
    if (addStatus) {
      setSelectedLocations([]);
      setSelectedLevels([]);
      setSelectedLevelsError(false);
      setSelectedLocationsError(false);
      reset();
      dispatch(updateJobAddStatus());
    }
  }, [addStatus]);

  const { job_levels, job_locations, page_title, content } = data;

  const handleDeleteJobAlert = (id) => {
    dispatch(deleteJobAlert({ id }));
  };

  const onLevelSelect = (selectedList, selectedItem) => {
    setSelectedLevelsError(false);
    let arr = [];
    selectedList.map((row) => {
      return arr.push(row.id);
    });
    setSelectedLevels(arr);
  };
  const onLevelRemove = (selectedList, removedItem) => {
    setSelectedLevelsError(false);
    let arr = [];
    selectedList.map((row) => {
      return arr.push(row.id);
    });
    setSelectedLevels(arr);
  };

  const onLocationSelect = (selectedList, selectedItem) => {
    setSelectedLocationsError(false);
    let arr = [];
    selectedList.map((row) => {
      return arr.push(row.id);
    });
    setSelectedLocations(arr);
  };
  const onLocationRemove = (selectedList, removedItem) => {
    setSelectedLocationsError(false);
    let arr = [];
    selectedList.map((row) => {
      return arr.push(row.id);
    });
    setSelectedLocations(arr);
  };

  const handleSaveJobAlert = (data) => {
    let valid = true;

    if (selectedLevels.length === 0) {
      setSelectedLevelsError(true);
      valid = false;
    }

    if (selectedLocations.length === 0) {
      setSelectedLocationsError(true);
      valid = false;
    }

    if (!valid) return;

    data.selected_levels = selectedLevels;
    data.selected_locations = selectedLocations;
    dispatch(saveJobAlert(data));
  };
  useDocumentTitle(page_title);
  return (
    <section id="dash">
      <Breadcrumb items={breadcrumbItems} />
      <div className="contain">
        <div className="alert_job_form">
          <div className="talent_top_bar">
            <h4 className="heading">Create a Job Alert</h4>
          </div>
          <form method="POST" onSubmit={handleSubmit(handleSaveJobAlert)}>
            <div className="form_row row">
              <div className="col-sm-4">
                <h6>Keywords</h6>
                <input
                  type="text"
                  name="keywords"
                  placeholder="i.e. Data Analyst"
                  className="input"
                  {...register("keyword", {
                    required: "keyword is required.",
                  })}
                />
                <span className="validation-error">
                  {errors.keyword?.message}
                </span>
              </div>
              <div className="col-sm-4">
                <h6>Job Level</h6>
                <Multiselect
                  options={job_levels}
                  selectedValues={job_levels?.filter((level) =>
                    selectedLevels.includes(level.id)
                  )}
                  onSelect={onLevelSelect}
                  onRemove={onLevelRemove}
                  displayValue="title"
                  showCheckbox={true}
                  className="multiselect-dropdown input"
                  avoidHighlightFirstOption={true}
                />
                {selectedLevelsError && (
                  <span className="validation-error">
                    Please select level(s).
                  </span>
                )}
              </div>
              <div className="col-sm-4">
                <h6>Location</h6>
                <Multiselect
                  options={job_locations}
                  selectedValues={job_locations?.filter((loc) =>
                    selectedLocations.includes(loc.id)
                  )}
                  onSelect={onLocationSelect}
                  onRemove={onLocationRemove}
                  displayValue="title"
                  showCheckbox={true}
                  className="multiselect-dropdown input"
                  avoidHighlightFirstOption={true}
                />
                {selectedLocationsError && (
                  <span className="validation-error">
                    Please select location(s).
                  </span>
                )}
              </div>
              <div className="col-sm-12">
                <div className="site_blk">
                  <button
                    class="site_btn"
                    type="submit"
                    disabled={isFormProcessing}
                  >
                    Create{" "}
                    <FormProcessingSpinner
                      isFormProcessing={isFormProcessing}
                    />
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div className="talent_top_bar mt-4 mb-4">
            <p>
              <Text string={content?.detail} parse={true} />
            </p>
          </div>
          <div className="divider_big_line"></div>
          <h4 className="heading">Job Alerts</h4>
          <div className="payment_history_table">
            <table>
              <thead>
                <tr>
                  <th width="30%">Keywords</th>
                  <th width="20%">Job Level</th>
                  <th width="40%">Location</th>
                  <th width="10%">Actions</th>
                </tr>
              </thead>
              <tbody>
                {alerts && alerts.length > 0 ? (
                  alerts.map((alert, index) => (
                    <tr>
                      <td>{alert.keyword}</td>
                      <td>{alert.job_level}</td>
                      <td>{alert.job_location}</td>
                      <td className="button_td">
                        <button
                          type="button"
                          onClick={() => handleDeleteJobAlert(alert.id)}
                          disabled={isDeleting}
                        >
                          <img
                            src={paths.SITE_BASE_URL + "/images/trash.svg"}
                          />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      {"The job alerts that you have generated will show here."}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobAlert;
